// /**
//  * Form Validation Hook
//  * 
//  * Custom hook for real-time form validation with German error messages.
//  */

// import { useState, useCallback } from 'react'

// // Validation messages in German
// const MESSAGES = {
//   fullName: {
//     required: 'Bitte geben Sie Ihren vollständigen Namen ein.',
//     minLength: 'Der Name muss mindestens 2 Zeichen lang sein.',
//     pattern: 'Bitte geben Sie einen gültigen Namen ein.'
//   },
//   email: {
//     required: 'Bitte geben Sie Ihre E-Mail-Adresse ein.',
//     invalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
//   },
//   whatsapp: {
//     required: 'Bitte geben Sie Ihre WhatsApp-Nummer ein.',
//     invalid: 'Bitte geben Sie eine gültige Telefonnummer ein.',
//     minLength: 'Die Nummer muss mindestens 8 Ziffern enthalten.'
//   }
// }

// /**
//  * Validate email format
//  */
// const isValidEmail = (email) => {
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
//   return emailRegex.test(email)
// }

// /**
//  * Validate phone number format
//  */
// const isValidPhone = (phone) => {
//   const phoneRegex = /^[\d\s\+\-\(\)]+$/
//   return phoneRegex.test(phone)
// }

// export function useFormValidation() {
//   const [values, setValues] = useState({
//     fullName: '',
//     email: '',
//     whatsappNumber: ''
//   })

//   const [errors, setErrors] = useState({
//     fullName: '',
//     email: '',
//     whatsappNumber: ''
//   })

//   const [touched, setTouched] = useState({
//     fullName: false,
//     email: false,
//     whatsappNumber: false
//   })

//   /**
//    * Validate a single field
//    */
//   const validateField = useCallback((name, value) => {
//     let error = ''

//     switch (name) {
//       case 'fullName':
//         if (!value.trim()) {
//           error = MESSAGES.fullName.required
//         } else if (value.trim().length < 2) {
//           error = MESSAGES.fullName.minLength
//         } else if (!/^[a-zA-ZäöüÄÖÜß\s\-']+$/.test(value)) {
//           error = MESSAGES.fullName.pattern
//         }
//         break

//       case 'email':
//         if (!value.trim()) {
//           error = MESSAGES.email.required
//         } else if (!isValidEmail(value)) {
//           error = MESSAGES.email.invalid
//         }
//         break

//       case 'whatsappNumber':
//         if (!value.trim()) {
//           error = MESSAGES.whatsapp.required
//         } else if (!isValidPhone(value)) {
//           error = MESSAGES.whatsapp.invalid
//         } else if (value.replace(/\D/g, '').length < 8) {
//           error = MESSAGES.whatsapp.minLength
//         }
//         break

//       default:
//         break
//     }

//     return error
//   }, [])

//   /**
//    * Handle input change
//    */
//   const handleChange = useCallback((e) => {
//     const { name, value } = e.target
//     setValues(prev => ({ ...prev, [name]: value }))

//     // Validate on change if field was touched
//     if (touched[name]) {
//       const error = validateField(name, value)
//       setErrors(prev => ({ ...prev, [name]: error }))
//     }
//   }, [touched, validateField])

//   /**
//    * Handle input blur
//    */
//   const handleBlur = useCallback((e) => {
//     const { name, value } = e.target
//     setTouched(prev => ({ ...prev, [name]: true }))
    
//     const error = validateField(name, value)
//     setErrors(prev => ({ ...prev, [name]: error }))
//   }, [validateField])

//   /**
//    * Validate entire form
//    */
//   const validateForm = useCallback(() => {
//     const newErrors = {
//       fullName: validateField('fullName', values.fullName),
//       email: validateField('email', values.email),
//       whatsappNumber: validateField('whatsappNumber', values.whatsappNumber)
//     }

//     setErrors(newErrors)
//     setTouched({
//       fullName: true,
//       email: true,
//       whatsappNumber: true
//     })

//     return !Object.values(newErrors).some(error => error !== '')
//   }, [values, validateField])

//   /**
//    * Reset form
//    */
//   const resetForm = useCallback(() => {
//     setValues({
//       fullName: '',
//       email: '',
//       whatsappNumber: ''
//     })
//     setErrors({
//       fullName: '',
//       email: '',
//       whatsappNumber: ''
//     })
//     setTouched({
//       fullName: false,
//       email: false,
//       whatsappNumber: false
//     })
//   }, [])

//   /**
//    * Get field status (for styling)
//    */
//   const getFieldStatus = useCallback((name) => {
//     if (!touched[name]) return ''
//     return errors[name] ? 'error' : 'success'
//   }, [touched, errors])

//   return {
//     values,
//     errors,
//     touched,
//     handleChange,
//     handleBlur,
//     validateForm,
//     resetForm,
//     getFieldStatus
//   }
// }


/**
 * Form Validation Hook
 * 
 * Custom hook for real-time form validation with German error messages.
 */

import { useState, useCallback } from 'react'

// Validation messages in German
const MESSAGES = {
  fullName: {
    required: 'Bitte geben Sie Ihren vollständigen Namen ein.',
    minLength: 'Der Name muss mindestens 2 Zeichen lang sein.',
    pattern: 'Bitte geben Sie einen gültigen Namen ein.'
  },
  email: {
    required: 'Bitte geben Sie Ihre E-Mail-Adresse ein.',
    invalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.'
  },
  whatsapp: {
    required: 'Bitte geben Sie Ihre WhatsApp-Nummer ein.',
    invalid: 'Bitte geben Sie eine gültige Telefonnummer ein.',
    minLength: 'Die Nummer muss mindestens 8 Ziffern enthalten.'
  },
  amount: {
    required: 'Bitte geben Sie einen Betrag ein.',
    invalid: 'Bitte geben Sie einen gültigen Betrag ein.',
    minimum: 'Der Betrag muss größer als 0 sein.',
    maximum: 'Der Betrag ist zu hoch.'
  },
  address: {
    required: 'Bitte geben Sie Ihre Adresse ein.',
    minLength: 'Die Adresse muss mindestens 5 Zeichen lang sein.',
    maxLength: 'Die Adresse ist zu lang (maximal 200 Zeichen).'
  }
}

/**
 * Validate email format
 */
const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

/**
 * Validate phone number format
 */
const isValidPhone = (phone) => {
  const phoneRegex = /^[\d\s\+\-\(\)]+$/
  return phoneRegex.test(phone)
}

/**
 * Validate amount format
 */
const isValidAmount = (amount) => {
  const amountRegex = /^\d+([.,]\d{1,2})?$/
  return amountRegex.test(amount)
}

export function useFormValidation() {
  const [values, setValues] = useState({
    fullName: '',
    email: '',
    whatsappNumber: '',
    amount: '',
    address: ''
  })

  const [errors, setErrors] = useState({
    fullName: '',
    email: '',
    whatsappNumber: '',
    amount: '',
    address: ''
  })

  const [touched, setTouched] = useState({
    fullName: false,
    email: false,
    whatsappNumber: false,
    amount: false,
    address: false
  })

  /**
   * Validate a single field
   */
  const validateField = useCallback((name, value) => {
    let error = ''

    switch (name) {
      case 'fullName':
        if (!value.trim()) {
          error = MESSAGES.fullName.required
        } else if (value.trim().length < 2) {
          error = MESSAGES.fullName.minLength
        } else if (!/^[a-zA-ZäöüÄÖÜß\s\-']+$/.test(value)) {
          error = MESSAGES.fullName.pattern
        }
        break

      case 'email':
        if (!value.trim()) {
          error = MESSAGES.email.required
        } else if (!isValidEmail(value)) {
          error = MESSAGES.email.invalid
        }
        break

      case 'whatsappNumber':
        if (!value.trim()) {
          error = MESSAGES.whatsapp.required
        } else if (!isValidPhone(value)) {
          error = MESSAGES.whatsapp.invalid
        } else if (value.replace(/\D/g, '').length < 8) {
          error = MESSAGES.whatsapp.minLength
        }
        break

      case 'amount':
        if (!value.trim()) {
          error = MESSAGES.amount.required
        } else if (!isValidAmount(value)) {
          error = MESSAGES.amount.invalid
        } else {
          const numValue = parseFloat(value.replace(',', '.'))
          if (numValue <= 0) {
            error = MESSAGES.amount.minimum
          } else if (numValue > 1000000) {
            error = MESSAGES.amount.maximum
          }
        }
        break

      case 'address':
        if (!value.trim()) {
          error = MESSAGES.address.required
        } else if (value.trim().length < 5) {
          error = MESSAGES.address.minLength
        } else if (value.trim().length > 200) {
          error = MESSAGES.address.maxLength
        }
        break

      default:
        break
    }

    return error
  }, [])

  /**
   * Handle input change
   */
  const handleChange = useCallback((e) => {
    const { name, value } = e.target
    setValues(prev => ({ ...prev, [name]: value }))

    // Validate on change if field was touched
    if (touched[name]) {
      const error = validateField(name, value)
      setErrors(prev => ({ ...prev, [name]: error }))
    }
  }, [touched, validateField])

  /**
   * Handle input blur
   */
  const handleBlur = useCallback((e) => {
    const { name, value } = e.target
    setTouched(prev => ({ ...prev, [name]: true }))
    
    const error = validateField(name, value)
    setErrors(prev => ({ ...prev, [name]: error }))
  }, [validateField])

  /**
   * Validate entire form
   */
  const validateForm = useCallback(() => {
    const newErrors = {
      fullName: validateField('fullName', values.fullName),
      email: validateField('email', values.email),
      whatsappNumber: validateField('whatsappNumber', values.whatsappNumber),
      amount: validateField('amount', values.amount),
      address: validateField('address', values.address)
    }

    setErrors(newErrors)
    setTouched({
      fullName: true,
      email: true,
      whatsappNumber: true,
      amount: true,
      address: true
    })

    return !Object.values(newErrors).some(error => error !== '')
  }, [values, validateField])

  /**
   * Reset form
   */
  const resetForm = useCallback(() => {
    setValues({
      fullName: '',
      email: '',
      whatsappNumber: '',
      amount: '',
      address: ''
    })
    setErrors({
      fullName: '',
      email: '',
      whatsappNumber: '',
      amount: '',
      address: ''
    })
    setTouched({
      fullName: false,
      email: false,
      whatsappNumber: false,
      amount: false,
      address: false
    })
  }, [])

  /**
   * Get field status (for styling)
   */
  const getFieldStatus = useCallback((name) => {
    if (!touched[name]) return ''
    return errors[name] ? 'error' : 'success'
  }, [touched, errors])

  return {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    validateForm,
    resetForm,
    getFieldStatus
  }
}